export default __webpack_public_path__ + "images/55c8fdfd18c2d25be922a2e95122d15f-science.webp";